'use client'

import { LanguageDropdown } from '@/components/language-dropdown'
import { FullscreenToggle } from '@/components/layout/full-screen-toggle'
import { UserDropdown } from '@/components/layout/user-dropdown'
import { ModeDropdown } from '@/components/mode-dropdown'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { ToggleMobileSidebar } from '../toggle-mobile-sidebar'

export function VerticalLayoutHeader() {
  return (
    <header className="sticky top-0 z-50 w-full bg-background border-b border-sidebar-border">
      <div className="flex h-14 justify-between items-center gap-4 mx-4">
        <ToggleMobileSidebar />
        <div className="grow flex justify-end gap-2">
          <SidebarTrigger className="hidden xl:flex xl:me-auto" />
          <FullscreenToggle />
          <ModeDropdown />
          <LanguageDropdown />
          <UserDropdown />
        </div>
      </div>
    </header>
  )
}
